import request from '@/utils/request'; // 获取仪表类型列表

export function fetchList(data) {
  return request({
    url: '/pmsservice/api/pmsMeter/list',
    method: 'post',
    data: data
  });
}
export function fetchCreate(data) {
  return request({
    url: '/pmsservice/api/pmsMeter/insert',
    method: 'post',
    data: data
  });
}
export function fetchDetail(data) {
  return request({
    url: '/pmsservice/api/pmsMeter/info',
    method: 'post',
    data: data
  });
}
export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/pmsservice/api/pmsMeter/delete',
    method: 'post',
    data: data
  });
}
export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/pmsMeter/update',
    method: 'post',
    data: data
  });
}